
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agreements/kvkk-clarification-text",
      function () {
        return require("private-next-pages/agreements/kvkk-clarification-text.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agreements/kvkk-clarification-text"])
      });
    }
  